/**
 * @file Created on Thu Nov 15 2018
 * @module utils
 * @author wangyongqing <wangyongqing01@baidu.com>
 */

export const isFunction = obj => typeof obj === 'function';
export function isPlainObject(obj) {
    if (typeof obj === 'object') {
        return Object.getPrototypeOf(obj) === null || Object === obj.constructor;
    }

    return false;
}
/**
 * 根据传入的端能力参数，返回正确的参数
 * 主要用于处理 name 和 data 的情况
 * 默认不传入 name 这层就可以
 * @function getParams
 * @param {string} name - name 参数
 * @param {object} params - 参数
 * @param {object} defaultParams - 默认参数
 * @return {object} 可用的完整参数
 */
export const getParams = (name, params = {}, defaultParams = {}) => {
    if (params.data && params.name) {
        return Object.assign(
            {
                name
            },
            defaultParams,
            params
        );
    } else {
        return Object.assign(
            {
                name
            },
            defaultParams,
            {data: params}
        );
    }
};
/**
 * alias encodeURIComponent
 * @function encode
 * @param {string} str - 需要 encode 的字符串
 */
export const encode = str => encodeURIComponent(str);
/**
 * alias decodeURIComponent
 * @function decode
 * @param {string} str - 需要 decode 的字符串
 */
export const decode = str => decodeURIComponent(str);

export const noEmptyQueryToJson = url => {
    let locse = url.split('?');
    let search = locse[1] ? locse[1] : locse[0];
    let pairs = search.split('&');
    let result = {};

    pairs.forEach(pair => {
        pair = pair.split('=');
        if (pair[0].length > 0) {
            let resultPair = '';
            try {
                resultPair = decode(pair[1]) || '';
            } catch (e) {
                resultPair = pair[1];
            }
            result[pair[0]] = resultPair;
        }
    });

    return result;
};

export const urlToSchema = url => {
    const style = encodeURIComponent(JSON.stringify({'menumode': '2', 'showtoolbar': '1'}));
    const urlStr = encodeURIComponent(url);
    return 'baiduboxapp://v1/easybrowse/open?newbrowser=1&style=' + style + '&url=' + urlStr;
};
